module.exports = __webpack_public_path__ + "assets/1865129870fedd9b56b561ab948bbf1a.png";